import * as React from "react"

import { cn } from "@/lib/utils"
import { PwInput } from "@/components/ui/pw-input"

const BASE = "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm"

const Input = React.forwardRef(({ className, type, noEye, ...props }, ref) => {
  if (type === "password" && !noEye) {
    return <PwInput ref={ref} className={cn(BASE, className)} {...props} />
  }
  return (
    <input
      type={type}
      className={cn(BASE, className)}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
